import {OrganizationSearchResult} from './organization.service';
import {ListEntry} from '../interfaces/colDef';

export type OrgPick = OrganizationSearchResult | ListEntry;

/**
 * Resolves a bst-list-adder[target="organization"] selection to exactly one
 * of a Client id (a brand-new Client from the picker's own "+ New client"
 * flow) or an Organization id (a catalogue org — the backend's
 * resolveProspectClient() resolves-or-creates the tenant's Client for it,
 * reactivating a terminal-status row if one already exists). A catalogue
 * pick never returns a clientId directly: has_existing_client_id is computed
 * with no status filter, so it can name an ARCHIVED/LOST Client, and only
 * the backend path performs the reactivation check.
 */
export function resolveOrgPick(picked: OrgPick | null | undefined): {clientId: number | null; organizationId: number | null} {
  if (picked == null) {
    return {clientId: null, organizationId: null};
  }
  const id = typeof picked.id === 'string' ? parseInt(picked.id, 10) : picked.id;
  if (!('aliases_count' in picked)) {
    // addnew path: NewClientDialogComponent already created a real Client row.
    return {clientId: id, organizationId: null};
  }
  const org = picked as OrganizationSearchResult;
  return {clientId: null, organizationId: org.id};
}
